import { Box, Stack, TextField, Button, Tooltip, Typography, Autocomplete } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { Colors } from '../../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import { CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from '../../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import { AddCircle } from '@material-ui/icons';
import Loader from '../../../../Components/Loader'
import { IP_routeList } from '../../../../Utility/Constants'
import { localGetItem } from '../../../../Utility/Services/CacheProviderService'

const ageTypeOptions = ['At Birth', 'Days', 'Weeks', 'Months', 'Years'];

export default function DocImmunizationMaster() {
    const [ImmunizationData, setImmunizationData] = useState([]);
    const [vaccinationRows, setVaccinationRows] = useState([{ id: 1, ageFrom: '', ageTo: '', ageType: '', vaccination: '', route: '', dosage: '' }]);
    const [nextRowId, setNextRowId] = useState(2);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [EditID, setEditID] = useState(null);
    const [isloader, setisloader] = useState(false);
    const [delIDs, setdelIDs] = useState([]);
    const [isDelete, setisDelete] = useState(false);
    const [CheckBoxList, setCheckBoxList] = useState([]);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [focusRowId, setFocusRowId] = useState(null);
    const vaccinationInputRefs = useRef({});

    useEffect(() => {
        getImmunizationData()
    }, [])

    useEffect(() => {
        if (focusRowId && vaccinationInputRefs.current[focusRowId]) {
            vaccinationInputRefs.current[focusRowId].focus();
            setFocusRowId(null);
        }
    }, [vaccinationRows, focusRowId]);

    const getImmunizationData = () => {
        setisloader(true)
        try {
            RestAPIService.getAll(Serviceurls.PD_IMMUNIZATION_MASTER)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        let data = response?.data?.data || []
                        setImmunizationData(data)
                        setisloader(false)
                    }
                }).catch(error => {
                    setisloader(false)
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error?.message)
                    }
                })
        } catch (error) {
            setisloader(false)
            errorMessage(error.message)
        }
    }

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }

    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }


    const tableView = () => {
        const grpDelete = () => {
            setisDelete(true)
        }
        const gridToolBar = () => {
            return (
                <Box>
                    <CommonGridToolBarWithFilterText DeleteBtnText={'Active/Inactive'} isDelete={delIDs?.length > 0} removeData={grpDelete.bind(this)} />
                </Box>
            )
        }

        const handleTableCheckbox = (id) => {
            let selectedIDs = new Set(id);
            setCheckBoxList(id)
            let selectedRows = ImmunizationData.filter((row) => selectedIDs.has(row.sno));
            let FinalData = []
            selectedRows.forEach((item) => {
                FinalData.push({ id: item?.id, is_active: item?.is_active })
            })
            setdelIDs(FinalData)
        }

        ImmunizationData?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: 'age_details', headerName: 'Age', flex: 0.15,
                renderCell: (params) => (params.row.age_details?.length > 30 ?
                    <Tooltip placement="top" title={`${params.row.age_details}`}><Typography fontSize={'0.9vw'}>{params.row.age_details.slice(0, 30) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.age_details}</Typography>)
            },
            {
                field: 'vaccination', headerName: 'Vaccination', flex: 0.27,
                renderCell: (params) => (params.row.vaccination?.length > 50 ?
                    <Tooltip placement="top" title={`${params.row.vaccination}`}><Typography fontSize={'0.9vw'}>{params.row.vaccination.slice(0, 50) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.vaccination}</Typography>)
            },
            {
                field: 'route', headerName: 'Route', flex: 0.15,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.route ? params?.row?.route : '-'}</Box>)
            },
            {
                field: 'dose', headerName: 'Dose', flex: 0.18,
                renderCell: (params) => (params.row.dose?.length > 31 ?
                    <Tooltip placement="top" title={`${params.row.dose}`}><Typography fontSize={'0.9vw'}>{params.row.dose.slice(0, 31) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.dose}</Typography>)
            },
            {
                field: 'status', headerName: 'Status', flex: 0.15, HeaderAlign: 'center', align: 'center',
                renderCell: (params) => (<Box component={'div'}>{params?.row?.is_active ? 'Active' : 'Inactive'}</Box>),
                valueGetter: (params) => {
                    const status = params.row?.is_active ? 'Active' : 'Inactive';
                    return `${status}`;
                }
            },
            {
                field: 'action', headerName: 'Action', flex: 0.1,
                renderCell: (params) => (
                    <Stack direction="row" alignItems="center" spacing={4}>
                        <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
                            <CommonEditButton disable={!params.row.is_active} size="1.5vw" onClick={() => {
                                let data = params.row
                                setEditID(data?.id)
                                setVaccinationRows([{
                                    id: data?.id,
                                    ageFrom: data?.age_type === 'At Birth' ? 0 : (data?.age_from || 0),
                                    ageTo: data?.age_type === 'At Birth' ? 0 : (data?.age_to || 0),
                                    ageType: data?.age_type || '',
                                    vaccination: data?.vaccination || null,
                                    route: IP_routeList.find((item) => item.value === data?.route) || null,
                                    dosage: data?.dose || '',
                                }])
                                setNextRowId(2)
                            }} />
                        </Stack>
                    </Stack>)
            }
        ]
        return (
            <Box sx={{ height: vaccinationRows.length > 1 ? '54vh' : '59vh', marginTop: '.5vw' }}>
                <DataGrid
                    checkboxSelection={true}
                    selectionModel={CheckBoxList}
                    onSelectionModelChange={(id) => handleTableCheckbox(id)}
                    rows={ImmunizationData}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    // hideFooter
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    getRowClassName={(params) => params.row.is_active === false ? 'gray-row' : ''}
                    sx={{
                        "& .gray-row .MuiDataGrid-cell": {
                            backgroundColor: "#e8e7e7 !important",
                            color: "black !important",
                        },
                        "& .gray-row:has(.MuiDataGrid-cell--checkbox)": {
                            backgroundColor: "white !important",
                            color: "black !important",
                        },
                        "& .gray-row .MuiDataGrid-cell:nth-child(1)": {
                            backgroundColor: "white !important",
                        }
                    }}
                    pagination
                    paginationMode="client"
                    headerHeight={40}
                    density='compact'
                    disableSelectionOnClick
                    page={page}
                    pageSize={pageSize}
                    onPageChange={(newPage) => setPage(newPage)}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[10, 20, 30]}
                    rowCount={ImmunizationData.length}
                    loading={isloader}
                />
            </Box>
        )
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const closeFilter = () => {
        setisDelete(false);
        setCheckBoxList([])
        setdelIDs([])
    }

    const clearFunction = () => {
        setVaccinationRows([{ id: 1, ageFrom: '', ageTo: '', ageType: '', vaccination: '', route: '', dosage: '' }]);
        setNextRowId(2);
        setEditID(null)
        setisDelete(false);
        setCheckBoxList([])
        setdelIDs([])
    }

    const inactiveHandelar = () => {
        try {
            const data = delIDs.map(item => ({
                id: item?.id,
                is_active: !item?.is_active
            }))
            setisloader(true)
            RestAPIService.updateWithOutId(data, Serviceurls.PD_IMMUNIZATION_MASTER)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        getImmunizationData()
                        clearFunction()
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    };

    const addImmunizationData = () => {
        let LoggedUserData = JSON.parse(localGetItem("loggedInUserInfo"))
        try {
            if (vaccinationRows[vaccinationRows.length - 1].ageFrom === "" || !vaccinationRows[vaccinationRows.length - 1].ageType || !vaccinationRows[vaccinationRows.length - 1].vaccination || !vaccinationRows[vaccinationRows.length - 1].dosage) {
                return errorMessage('Please Enter All mandatory fields')
            } else if ((vaccinationRows[vaccinationRows.length - 1].ageFrom >= vaccinationRows[vaccinationRows.length - 1].ageTo) && (vaccinationRows[vaccinationRows.length - 1].ageType !== 'At Birth') && vaccinationRows[vaccinationRows.length - 1].ageTo !== '') {
                return errorMessage('Age To must be greater than Age From in the last row.')
            }

            let data = vaccinationRows.map(row => ({
                age_from: row?.ageType === 'At Birth' ? 0 : (row?.ageFrom || ''),
                age_to: row?.ageType === 'At Birth' ? 0 : (row?.ageTo || ''),
                age_type: row?.ageType || null,
                age_details: row?.ageType === 'At Birth' ? row.ageType : row.ageFrom + (row.ageTo ? ' - ' + row.ageTo : '') + ' ' + (row.ageType || ''),
                vaccination: row?.vaccination || '',
                route: row?.route?.value || null,
                dose: row?.dosage || '',
                doctor_id: LoggedUserData?.doctor_id,
                is_active: true,
                ...(EditID && { id: EditID })
            }))
            setisloader(true)
            const apiCall = EditID ? RestAPIService.updateWithOutId(data, Serviceurls.PD_IMMUNIZATION_MASTER) : RestAPIService.create(data, Serviceurls.PD_IMMUNIZATION_MASTER)
            apiCall.then((response) => {
                if (response.data.status === 'success') {
                    successMessage(response.data.message)
                    getImmunizationData()
                    clearFunction()
                    setEditID(null)
                    setisloader(false)
                }
            }).catch(e => {
                setisloader(false)
                if (e?.response?.data?.status === 'fail') {
                    errorMessage(e.response.data.message)
                } else {
                    errorMessage(e.message)
                }
            })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const handleVaccinationRowChange = (id, field, value) => {
        setVaccinationRows(vaccinationRows.map(row =>
            row.id === id ? { ...row, [field]: value } : row
        ));
    };

    const handleVaccinationRowMultiChange = (id, updatedFields) => {
        setVaccinationRows(prevRows =>
            prevRows.map(row =>
                row.id === id ? { ...row, ...updatedFields } : row
            )
        );
    };

    const addVaccinationRow = () => {
        const lastRow = vaccinationRows[vaccinationRows.length - 1];
        if (lastRow.ageFrom === "" || !lastRow.ageType || !lastRow.vaccination || !lastRow.dosage) {
            errorMessage('Please fill the mandatory fields in the last row before adding a new one.');
            return;
        } else if (lastRow.ageFrom >= lastRow.ageTo && lastRow.ageType !== 'At Birth' && lastRow.ageTo !== '') {
            errorMessage('Age To must be greater than Age From in the last row.');
            return;
        }
        const newRowId = nextRowId;
        setVaccinationRows([...vaccinationRows, { id: nextRowId, ageFrom: lastRow.ageFrom, ageTo: lastRow.ageTo, ageType: lastRow.ageType, vaccination: '', route: '', dosage: '' }]);
        setNextRowId(nextRowId + 1);
        setFocusRowId(newRowId);
    };

    const removeVaccinationRow = (id) => {
        if (vaccinationRows.length > 1) {
            setVaccinationRows(vaccinationRows.filter(row => row.id !== id));
        }
    };

    return (
        <Box component={'div'} sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box component={'div'} sx={{ height: 'auto', width: '93vw', backgroundColor: 'white', padding: '.6vw' }}>
                <Box sx={{ height: vaccinationRows.length > 1 ? '7.5vw' : '4vw', overflowY: 'auto' }}>
                    {vaccinationRows.map((row) => (
                        <Box key={row.id} sx={{ display: 'flex', gap: '0.8vw', mb: '1vw', alignItems: 'flex-start', flexWrap: 'wrap', paddingTop: '0.3vw' }}>
                            <TextField
                                label="Age From *"
                                size="small"
                                value={row.ageFrom}
                                disabled={row.ageType === 'At Birth' || vaccinationRows.length > 1 ? true : false}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const num = Number(value);
                                    if (value === "") {
                                        handleVaccinationRowChange(row.id, 'ageFrom', "");
                                        return;
                                    }
                                    if (!/^\d+$/.test(value)) return;
                                    if (num >= 0 && num <= 99) {
                                        handleVaccinationRowChange(row.id, 'ageFrom', num);
                                    }
                                }}
                                sx={{ width: '10vw' }}
                            />

                            <TextField
                                label="Age To"
                                size="small"
                                value={row.ageTo}
                                disabled={row.ageFrom === "" || row.ageType === 'At Birth' || vaccinationRows.length > 1 ? true : false}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const num = Number(value);
                                    if (value === "") {
                                        handleVaccinationRowChange(row.id, 'ageTo', "")
                                        return;
                                    }
                                    if (!/^\d+$/.test(value)) return;
                                    if (num >= 0 && num <= 99) {
                                        handleVaccinationRowChange(row.id, 'ageTo', num)
                                    }
                                }}
                                sx={{ width: '10vw' }}
                            />
                            <Autocomplete
                                options={ageTypeOptions}
                                value={row.ageType}
                                disabled={vaccinationRows.length > 1}
                                onChange={(e, newValue) => {
                                    if (newValue === 'At Birth') {
                                        handleVaccinationRowMultiChange(row.id, {
                                            ageType: newValue,
                                            ageFrom: 0,
                                            ageTo: 0,
                                        });
                                    } else {
                                        handleVaccinationRowChange(row.id, 'ageType', newValue || '')
                                    }
                                }
                                }
                                renderInput={(params) => <TextField {...params} label="Age Type *" disabled={vaccinationRows.length > 1} size="small" sx={{ width: '15vw' }} />}
                            />
                            <TextField
                                label="Vaccination *"
                                size="small"
                                inputProps={{ maxLength: 50 }}
                                value={row.vaccination}
                                inputRef={(el) => {
                                    vaccinationInputRefs.current[row.id] = el;
                                }}
                                onChange={(e) => handleVaccinationRowChange(row.id, 'vaccination', e.target.value)}
                                sx={{ width: '15vw' }}
                            />
                            <Autocomplete
                                options={(IP_routeList.length != 0) ? IP_routeList : []}
                                getOptionLabel={option => typeof (option) === "string" ? option : option.value}
                                value={row.route}
                                onChange={(e, newValue) => handleVaccinationRowChange(row.id, 'route', newValue || '')}
                                renderInput={(params) => <TextField {...params} label="Route" size="small" sx={{ width: '14.8vw' }} />}
                            />
                            <TextField
                                label="Dose *"
                                size="small"
                                inputProps={{ maxLength: 50 }}
                                value={row.dosage}
                                onChange={(e) => handleVaccinationRowChange(row.id, 'dosage', e.target.value)}
                                sx={{ width: '14.8vw' }}
                            />
                            {vaccinationRows.length > 1 && (
                                <Button
                                    variant="outlined"
                                    color="error"
                                    onClick={() => removeVaccinationRow(row.id)}
                                    sx={{ marginTop: '0.1vw', textTransform: 'capitalize' }}
                                >   Remove
                                </Button>
                            )}
                        </Box>
                    ))}
                </Box>
                <Box sx={{ display: 'flex', marginTop: '0.75vw', justifyContent: 'flex-end', gap: '1vw' }}>
                    <Button
                        className='eMed_New_Ip_Btn'
                        startIcon={<AddCircle />}
                        disabled={EditID ? true : false}
                        onClick={addVaccinationRow}
                    >
                        Add Another Vaccination
                    </Button>
                    <Button size='small' variant='outlined' sx={{ textTransform: 'capitalize', width: '7vw' }} onClick={() => { clearFunction() }}>Clear</Button>
                    <Button size='small' variant='contained' sx={{ textTransform: 'capitalize', width: '7vw' }} onClick={() => { addImmunizationData() }}>{EditID ? 'Update' : 'Save'}</Button>
                </Box>
            </Box>
            <Box component={'div'} sx={{ height: vaccinationRows.length > 1 ? '54vh' : '59vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white' }}>
                {tableView()}
            </Box>
            {errorMsg && <ToastMsg severity={'error'} msg={errorMsgText} msgPop={msgClose} />}
            {successMsg && <ToastMsg severity={'success'} msg={successMsgText} msgPop={msgClose} />}
            {isDelete && <DeletePopup ButtonText={'Active/Inactive'} DeletTitle={`Are you sure, Do you want to Active/Inactive this item ?`} DeleteNotify={"If you Active/Inactive this, this could be effect in entire Configuration"} removeData={inactiveHandelar} deleteAlertPopupClose={closeFilter} />}
            <Loader loaderOpen={isloader} />
        </Box>
    )
}